<div class="lui-drawer-bottom-panel">
  <div class="lui-drawer-bottom-panel-container">
    <div class="lui-drawer-bottom-panel-content">
      <ng-content select="[luiDrawerBottomPanelContent]"></ng-content>
    </div>
    <div class="lui-drawer-bottom-panel-control">
      <ng-content select="[luiDrawerBottomPanelControl]"></ng-content>
    </div>
  </div>
</div>
<div class="lui-drawer-bottom-inner-container" cdkScrollable #content>
  <ng-content></ng-content>
</div>
